import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import { renderDeleteFidelCard } from "../../Organisms/Modals/Fidel/delete-fidel-card";

import useFidel from "../../CustomHooks/useFidel";

import { useModalContext } from "../../Contexts/ModalContext";

import { useGetFidelCards } from "../../CustomHooks/Queries";

import { AmericanExpress, Mastercard, VisaLogo, DebitCards } from "../../Assets/Images/";
import { Trash } from "../../Assets/Icons";
import { BackIcon } from "./nn-icons";

const FidelCard = ({ card }) => {
  const modalContext = useModalContext();

  const handleDeleteFidelCard = (e, card) => {
    e.stopPropagation();
    renderDeleteFidelCard(modalContext, card);
  };

  const cardCompanyLogo = useMemo(() => {
    if (card?.card_type === "Visa") {
      return <VisaLogo />;
    } else if (card?.card_type === "Amex") {
      return <AmericanExpress />;
    } else if (card?.card_type === "Mastercard") {
      return <Mastercard />;
    } else {
      return <VisaLogo />;
    }
  }, [card?.card_type]);

  return (
    <div className="fidel-card">
      <div className="card-info">
        <div className="card-logo">{cardCompanyLogo}</div>
        <div className="card-details">
          <span className="card-type">*******{card?.card_last_4_digits}</span>
          <span className="card-expiry">
            Exp. date: {card?.exp_month}/{card?.exp_year % 100}
          </span>
        </div>
      </div>
      <div className="actions">
        <button className="delete" onClick={(e) => handleDeleteFidelCard(e, card)} aria-label="Remove linked card">
          <Trash />
        </button>
      </div>
    </div>
  );
};

function NeighborhoodNetworkCards() {
  const navigate = useNavigate();

  const { isLoadingFidel, linkingCard, LinkCard } = useFidel();

  const { isLoading: isLoadingFidelCards, data: fidelCards } = useGetFidelCards();

  const stakeCheckingCards = useMemo(() => fidelCards?.filter((card) => card.is_stake_checking), [fidelCards]);
  const otherCards = useMemo(() => fidelCards?.filter((card) => !card.is_stake_checking), [fidelCards]);

  const isLoading = isLoadingFidelCards || isLoadingFidel;

  return (
    <div className="nn-page linked-cards anim-ready">
      <section>
        <div className="max-width-container">
          <div className="nn-content-card">
            <div className="nn-card-header">
              <button type="button" className="nn-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
                <BackIcon />
              </button>
              <h1>My Cards</h1>
              <span className="nn-header-spacer" />
            </div>
            {isLoading ? (
              <div className="loading-content">
                <CircularProgress />
              </div>
            ) : fidelCards?.length > 0 ? (
              <>
                <div className="top-container">
                  {stakeCheckingCards.length > 0 && (
                    <>
                      <h4 className="text-lg-semibold color--mist mb-4">Stake Checking Card</h4>
                      {stakeCheckingCards.map((card, idx) => (
                        <FidelCard key={idx} card={card} />
                      ))}
                    </>
                  )}
                  <h4 className="text-lg-semibold color--mist mb-4">Other Cards</h4>
                  {otherCards.map((card, idx) => (
                    <FidelCard key={idx} card={card} />
                  ))}
                </div>
                <div className="bottom-container">
                  <button type="button" className="nn-link-btn" onClick={LinkCard} disabled={linkingCard}>
                    Add New Card {linkingCard && <CircularProgress size={14} />}
                  </button>
                </div>
              </>
            ) : (
              <div className="no-debit-cards">
                <div className="card-icon mb-8">
                  <DebitCards />
                </div>
                <h2 className="no-cards-title mb-1">No Cards Linked</h2>
                <p className="no-cards-message mb-sm-6 mb-5">You don’t have any cards linked to Fidel.</p>
                <button type="button" className="nn-link-btn" onClick={LinkCard} disabled={linkingCard}>
                  Link Credit or Debit Card {linkingCard && <CircularProgress size={14} />}
                </button>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default NeighborhoodNetworkCards;
